module.exports = __webpack_public_path__ + "static/media/people.4881b90e.svg";